import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Config from "../../helper/Config";

export default class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    menuClick() {
        document.getElementById("navbar-mobile-icon").click();
        window.scrollTo(0, 0);
    }

    setIsShown(e, action) {
        if (window.innerWidth > 768) {
            if (action === "open") {
                e.currentTarget.classList.add("open")
            } else {
                e.currentTarget.classList.remove("open")
            }
        }
    }

    render() {
        let { page, style } = this.props;
        var menuTextColorClass = "nav-link"
        return (
            <React.Fragment>

                <nav id="menu" style={style} className="menu-fixed">
                    <button className="navbar-toggle" id={"navbar-mobile-icon"} type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className={`nav navbar-nav navbar-right`}>
                            <li className={page === "home" ? "nav-item px-2 active" : "nav-item px-2"} >
                                <Link to={Config.projectUrl + "/global-initiatives"} className={menuTextColorClass} onClick={() => this.menuClick()}>
                                Global <br/>Initiatives
                                </Link>
                            </li>
                            <li className={page === "home" ? "nav-item px-2 active" : "nav-item px-2"} >
                                <Link to={Config.projectUrl + "/nairobi-june-2024"} className={menuTextColorClass} onClick={() => this.menuClick()}>
                                Nairobi<br/>June 2024
                                </Link>
                            </li>
                            <li className={page === "home" ? "nav-item px-2 active" : "nav-item px-2"} >
                                <Link to={Config.projectUrl + "/ght-resources"} className={menuTextColorClass} onClick={() => this.menuClick()}>
                                GHT<br/>Resources
                                </Link>
                            </li>
                            <li className={page === "home" ? "nav-item px-2 active" : "nav-item px-2"} >
                                <Link to={Config.projectUrl + "/ght-qrcode"} className={menuTextColorClass} onClick={() => this.menuClick()}>
                                GHT<br/>QR Code
                                </Link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </React.Fragment>
        )
    }
}